var _excluded = ["onNextClick", "onPrevClick", "onOutsideClick", "onTriggerClick", "onCloseClick", "nextButtonLabel", "prevButtonLabel", "placement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from '../../../../../utils';
import { BasePopover } from '../../../../internal/BasePopover';
import { verticalPlacementEdges } from '../../../../internal/BasePopover/basePopover.utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var TourPopover = forwardRef((_ref, ref) => {
  var {
    onNextClick,
    onPrevClick,
    onOutsideClick,
    onTriggerClick,
    onCloseClick,
    nextButtonLabel = 'Next',
    prevButtonLabel,
    placement = 'bottom-end'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleOnOpenChange = (_isOpen, triggerEvent) => {
    if (triggerEvent === 'outside') {
      onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick();
    } else if (triggerEvent === 'close') {
      onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
    } else if (triggerEvent === 'children') {
      onTriggerClick === null || onTriggerClick === void 0 ? void 0 : onTriggerClick();
    }
  }; // converting the placements because the design placements requirements are different from the actual floating-ui's placements.


  var convertedPlacement = verticalPlacementEdges.includes(placement) ? placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start') : placement;
  return /*#__PURE__*/_jsx(BasePopover, _objectSpread(_objectSpread({
    "data-component": "TourPopover"
  }, props), {}, {
    onOpenChange: handleOnOpenChange,
    actionProps: {
      label: nextButtonLabel,
      onClick: () => onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick()
    },
    backProps: prevButtonLabel ? {
      label: prevButtonLabel,
      onClick: () => onPrevClick === null || onPrevClick === void 0 ? void 0 : onPrevClick()
    } : undefined,
    triggerEvent: "click",
    closeButtonSize: "small",
    placement: convertedPlacement,
    ref: ref,
    enableAnimationFrame: true
  }));
});
TourPopover.displayName = 'TourPopover';
//# sourceMappingURL=TourPopover.js.map